import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet';
import Header from '../../../../Components/Header';
import Footer from '../../../../Components/Footer';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import SVGCurveLine from '../../../../Hooks/SVGCurveLine'; 
import { GoNorthStar } from "react-icons/go";
import { PiSlideshow, PiStarFourFill } from "react-icons/pi";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { GoPlus } from "react-icons/go";
import starY from '../../../../Assets/Images/icons/star.webp';

import logo from "../../../../Assets/Images/logos/work/tataMotors2.png"
import ourwork1 from '../../../../Assets/Images/work/tata-trucks/tata-main.webp';
import ourwork2 from '../../../../Assets/Images/work/tata-trucks/tata-slide1.webp';
import ourwork3 from '../../../../Assets/Images/work/tata-trucks/tata-slide2.webp';
import ourwork4 from '../../../../Assets/Images/work/tata-trucks/tata-slide3.webp';
import ourwork5 from '../../../../Assets/Images/work/tata-trucks/tata-slide4.webp';
import ourwork6 from '../../../../Assets/Images/work/tata-trucks/tata-slide5.webp';
import ourwork7 from '../../../../Assets/Images/work/tata-trucks/tata-slide6.webp';

import CaseStudyNav from '../../../../Components/TechCaseStudyNav';
const externalLink = "https://trucks.tatamotors.com/";

// CaseStudySlider 
const CaseStudySlider = {
    dots: false,
    arrows: false,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 7000,
    speed: 700,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
    {
        breakpoint: 968,
        settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        },
    },
    {
        breakpoint: 768,
        settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        },
    },
    ],
};
// CaseStudySlider End

// Slider

const mainSlider ={
    dot: false,
    arrows:true,
    infinite:true,
    autoplay:true,
    autoplaySpeed: 7000,
    speed:700,
    slideToShow:3,
    SlideshowToScroll:1,
    responsive: [
        {
            breakpoint:768,
            settings:{
                arrow:false,
            }
        }
    ]
}

// Slider

//CaseStudy Data
const CaseStudyData = [
    {
        link: '#',
        image: ourwork1,
        titale: 'Brand led site for a Banking Solutions Firm',
        tags: [{ name: 'BFSI' },],
    },  
    {
        link: '#',
        image: ourwork2,
        titale: 'A dynamic website for India’s biggest truck company',
        tags: [
            { name: 'Automobile' },
        ],
    },  
    {
        link: '#',
        image: ourwork3,
        titale: 'Revamped Website for one of the India’s biggest institution',
        tags: [{ name: 'Education' },],

    },
  ];
//CaseStudy Data End

const TataTrucks = () => {


      return (
      <>
    
    
        <Helmet>
          <title>Tata Motors Commercial Vehicles: Visibility Case Study</title>
          <link rel="canonical" href="https://www.agency09.in/about"/>
          <meta name="robots" content="index, follow"/> 
    
          <meta name="description" content="Boosted visibility and engagement for Tata Motors commercial vehicles through data-driven digital marketing strategies by – AGENCY09"/>
          <meta property="og:title" content="Tata Motors Commercial Vehicles: Visibility Case Study"/> 
          <meta property="og:description" content="Boosted visibility and engagement for Tata Motors commercial vehicles through data-driven digital marketing strategies by – AGENCY09"/> 
          <meta property="og:image" content="https://www.agency09.in/agency09.png"/> 
          <meta property="og:type" content="website"/> 
    
    
          <meta name="twitter:card" content="summary"/> 
          <meta name="twitter:site" content="@AGENCY09"/> 
          <meta name="twitter:creator" content="@AGENCY09"/> 
          <meta name="twitter:url" content="https://www.agency09.in/about"/> 
          <meta name="twitter:description" content=" Boosted visibility and engagement for Tata Motors commercial vehicles through data-driven digital marketing strategies by – AGENCY09"/> 
          <meta name="twitter:image" content="https://www.agency09.in/agency09.png"/> 
    
        </Helmet>

    <Header/>
    <div className="spacer"></div>


    <section className='cSsecMin'>
        <div className='container'>
            
            <div className='cSsecMinA flexBio'>

                <div className='cSsecMinBtn m0'>
                <Link to='/work/case-studies' className='backBtn'><span><IoArrowBackCircleOutline /> Case Study</span></Link>
                </div>

                <div className='cSsecMinHead m0'>
                    <h1 className='sizeH4'>Driving Visibility and Engagement for Tata Motors' Commercial Vehicle Lineup</h1>
                </div>

                <div className='cSsecMinInfo m0'>
                    <img src={logo} loading='lazy' />
                    {/* <Link>Info <GoPlus /></Link> */}
                </div>

            </div>

            <div className='strokeB'>
                <SVGCurveLine/>
            </div>  


            <div className='cSsecMinB'>
                <div className='cSsecMinBRow'>
                    <div className='cSsecMinBCol'>
                        <h4>Overview</h4>
                        <p>To enhance the online presence and brand visibility of Tata Motors' commercial vehicle range, we developed five dynamic websites. These sites were specifically designed to highlight Tata Motors' diverse lineup, including small trucks, medium trucks, and buses & vans. The objective was to drive online engagement, showcase the reliability and performance of the vehicles, and provide a seamless user experience.</p>


                    </div>


                    <div className='cSsecMinBCol'>
                        <h4>Industry</h4>
                        <p>Automotive</p>
                    </div>

                    <div className='cSsecMinBCol'>
                        <h4>Services</h4>
                        <ul>
                            <li>Digital Strategy</li>
                            <li>Web Development</li>
                        </ul>
                    </div>

                    <div className='cSsecMinBCol'>
                        <h4>Challenges</h4>
                        <ul>
                            <li>Creating a robust online presence for multiple vehicle categories.</li>
                            <li>Ensuring high user engagement and an intuitive browsing experience across the websites.</li>
                        </ul>
                    </div>

                    <div className='cSsecMinBCol'>
                        <h4>Approach</h4>
                        <ul>
                            <li>Developed websites featuring high-quality visuals and comprehensive information about each vehicle range.</li>
<li>Incorporated interactive elements to engage users and provide an in-depth look at each vehicle's features and benefits.</li>
<li>Ensured easy navigation and user-friendly design for a seamless browsing experience.</li>
                            </ul>
                    </div>

                    <div className='cSsecMinBCol'>
                        <h4>Results</h4>
                        <ul>
                            <li>Significant increase in online engagement.</li>
                            <li>Users spent more time exploring the detailed features of Tata Motors' commercial vehicles.</li>
                            <li>Enhanced Tata Motors' position as a leader in the commercial vehicle market.</li>
                        </ul>
                    </div>

                    <div className='cSsecMinBCol'>
                        <h4>Year</h4>
                        <p>2023</p>
                    </div>

                </div>

            </div>


            <div className='cSsecMinC'>

                <div className='imgCol1 imgCol'>
                    <span><img src={ourwork1} loading='lazy' /></span>
                </div>

                

            </div>


<div className='mainslider'>
    <Slider {...mainSlider} className='clientelSlider slick-slider'>
    <div className='imgCol1 imgCol'>
                    <span><img src={ourwork2} loading='lazy' /></span>
                </div>

                <div className='imgCol1 imgCol'>
                    <span><img src={ourwork3} loading='lazy' /></span>
                </div>

                <div className='imgCol1 imgCol'>
                    <span><img src={ourwork4} loading='lazy' /></span>
                </div>

                <div className='imgCol1 imgCol'>
                    <span><img src={ourwork5} loading='lazy' /></span>
                </div>

                <div className='imgCol1 imgCol'>
                    <span><img src={ourwork6} loading='lazy' /></span>
                </div>

                <div className ='imgCol1 imgCol'>
                    <span><img src={ourwork7} loading='lazy' /></span>
                </div>
    </Slider>
</div>

        </div>
    </section>

{/* 
    <div className='container'>
    <div className='strokeB'>
              <SVGCurveLine />
    </div>
    </div>

    
    <section className='solutionsSecCaseStudy'>
            <div className='container'>

            <div className='Heading center HeadingIcon'>
                <h2 className='sizeH1 uppercase'>
                    <span className='iconSVG'><i className='iconF'><img src={starY} alt='Star Icon' /></i></span>
                    Related Work
                    <span className='iconSVG'><i className='iconF'><img src={starY} alt='Star Icon' /></i></span>
                </h2>
            </div>


            <div className='solutionsSecCaseStudyList'>

                <Slider {...CaseStudySlider} className='CaseStudySlider slick-slider'>
                    {CaseStudyData.map((CaseStudy, index) => (
                        <div key={index} className='item'>
                        <div className='CaseStudyCol'>
                            <Link to={CaseStudy.link}>
                                <div className='CaseStudyImg'><img src={CaseStudy.image}/></div>
                                <div className='CaseStudyTitale'>{CaseStudy.titale}</div>
                                <div className='textTag'><p>{CaseStudy.tag}
                                
                                {CaseStudy.tags.map((tag, index) => (
                                  <span key={index}>{tag.name}</span>
                                ))}
                                
                                </p></div>
                            </Link>
                        </div>
                        </div>
                    ))}
                </Slider>

            <div className='btnSpaceEx center'>     
                <Link to="/work/case-studies" className="btnDark fontM ripple-button"><span>View All</span></Link>
            </div>

            </div>

            </div>
        </section>  

 */}

<div className='btnSpaceEx center'><a href={externalLink} target="_blank" rel="noreferrer" className="btnDark fontM ripple-button"><span>Visit Site</span></a></div>
<CaseStudyNav visitLink={externalLink} />

    <Footer/>
    </>
  )
}

export default TataTrucks
